<div class="profile-img" [ngClass]="[wrapperClass, profileType]">
    @if (!showImage && initials) {
        <span class="initials">{{ initials }}</span>
    } @else {
        <img 
            [src]="imageUrl" 
            [alt]="alt" 
            [ngClass]="imgClass" 
            onerror="
                this.onerror = null;
                this.src = 'assets/images/home-logo.svg';
            " />
    }
</div>
